import { createFetcher } from '../contexts/Fetcher';
import { apiCloudLive } from '../resources/api/apiCloudLive';

const { useGetRegions } = apiCloudLive;

export const LiveRegionsFetcher = createFetcher(() => {
  return useGetRegions().execute;
});
